import LoginPage from './LoginPage';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { login, resetLoginInfo } from '../../../actions/authentication_actions';
import { newAlert } from '../../../actions/alert_actions';
import {
  fetchSessionData,
  confirmTokenRecaptchaInvisible,
  recaptchaValidationActivation
} from '../../../actions/session_actions';

function mapStateToProps(state) {
  const { loggedIn, qrImageUrl, needVerification } = state.authentication;
  return {
    loggedIn,
    qrImageUrl,
    needVerification,
    loading: state.requestState.requestLoginSend,
    loadingRecaptchaInvisible:
      state.requestState.requestConfirmTokenRecaptchaInvisibleSend,
    companyCode: state.sessionData.companyName,
    confirmCaptcha: state.sessionData.confirmCaptcha,
    isRecaptchaValidationActive: state.sessionData.isRecaptchaValidationActive
  };
}
function mapDispatchToProps(dispatch) {
  return {
    login: bindActionCreators(login, dispatch),
    resetLoginInfo: bindActionCreators(resetLoginInfo, dispatch),
    newAlert: bindActionCreators(newAlert, dispatch),
    fetchSessionData: bindActionCreators(fetchSessionData, dispatch),
    recaptchaValidationActivation: bindActionCreators(recaptchaValidationActivation, dispatch),
    confirmTokenRecaptchaInvisible: bindActionCreators(
      confirmTokenRecaptchaInvisible,
      dispatch
    )
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginPage);
